module.exports = __webpack_public_path__ + "img/smg51_card.47e0e187.png";